// extracted by mini-css-extract-plugin
export default {"melodyVideo":"HM-z","isFullWidth":"IM-z","landingPageVideo":"JM-z","play":"KM-z","iframeVideo":"LM-z","playHidden":"MM-z","fullwidth":"NM-z"};